import { useContext } from 'react';
import { VideoGenContext } from 'context/VideoGenContext';

const useVideoGenContext = () => {
  return { ...useContext(VideoGenContext) };
};

export default useVideoGenContext;
